// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"13ed262d","455":"45bc76d7","977":"dcc6803a"}[chunkId] + ".chunk.js";
};